import {useStore} from "react-redux";
import {IState} from "../store/reducer";
import {mapDispatchToProps} from "../store/connect";
import {useMemo} from "react";

export default function useRedux() {
    const store = useStore<IState>();
    const storeData = store.getState();
    const dispatch = mapDispatchToProps(store.dispatch);

    const reduxGetter = useMemo(() => {

        return {
            unconnected: !storeData.address || !storeData.network,
            walletInfo: storeData.wallet_info,
        }
    }, [storeData]);

    return {store, storeData, dispatch, reduxGetter}
}
